<template>
    <div>
        <div class="card-body" style="border:1px solid #e9dbdb;font-size:13px;" v-if="searchdetails && !showLuckyWinner">
            <div class="col-md-12">
                <div class="row">
                    <label class="col-lg-4 co-md-3 control-label ">
                        <h5> Search Records</h5>
                    </label>
                </div>
                <div class="form-group mb-2 ">
                    <div class="customer-quick-search">
                        <div class="customer-search-section-title">Quick customer search</div>
                        <div class="row align-items-end">
                            <div class="col-md-4 row">
                                <label><b>Customer Name</b></label>
                                <input class="form-control form-cascade-control input-small" type="text"
                                    v-model="customername" placeholder="Search by name">
                            </div>
                            <div class="col-md-4 row">
                                <label><strong>VSDIGI Id</strong></label>
                                <input class="form-control form-cascade-control input-small" type="text"
                                    v-model="generatedid" placeholder="Search by VSDIGI ID">
                            </div>
                            <div class="col-md-4 row">
                                <label><strong>Mobile</strong></label>
                                <input class="form-control form-cascade-control input-small" type="number"
                                    v-model="mobile" placeholder="Search by mobile">
                            </div>
                            <div class="col-md-12 quick-search-action">
                                <button @click="quickSearch()" class="btn bg-success text-white username btnsearch"
                                    type="button"><i class='bx bx-search-alt-2'></i> Search</button>
                            </div>
                        </div>
                    </div>
                    <div class="customer-advanced-search">
                    <div class="customer-search-section-title">Advanced filters</div>
                    <div class="row">
                        <div class="col-md-4 row">
                            <label><b>Registration Type</b></label>
                            <!-- none ticked = All -->
                            <div class="form-control form-cascade-control input-small registration-type-checks">
                                <input type="checkbox" id="regtypeAll" :checked="registation_type.length == 0"
                                    @change="registation_type = []" />
                                <label for="regtypeAll" class="mr-3">All</label>
                                <template v-for="option in registrationTypeOptions">
                                    <input type="checkbox" :id="'regtype' + option.value" :value="option.value"
                                        v-model="registation_type" :key="'c' + option.value" />
                                    <label :for="'regtype' + option.value" class="mr-3" :key="'l' + option.value">{{ option.label }}</label>
                                </template>
                            </div>
                        </div>
                        <div class="col-md-4 row">
                            <label><strong>Address</strong></label>
                            <input class="form-control form-cascade-control input-small" type="text" v-model="address">
                        </div>
                        <div class="col-md-4 row">
                            <label><strong>Aadhar No</strong></label>
                            <input class="form-control form-cascade-control input-small" type="number"
                                v-model="aadharno">
                        </div>
                        <div class="col-md-4 row">
                            <label><strong>D.O.B : From</strong></label>
                            <input class="form-control form-cascade-control input-small" v-model="dobfrom" type="date">
                        </div>
                        <div class="col-md-4 row">
                            <label><strong>D.O.B : To</strong></label>
                            <input class="form-control form-cascade-control input-small" v-model="dobto" type="date">
                        </div>
                        <div class="col-md-4 row">
                            <label><strong>By Gender</strong></label>
                            <select v-model="gender" class="form-control form-cascade-control input-small">
                                <option v-for="option in getmastertype(MASTER_GENDER)" v-bind:key="option.labelid"
                                    v-bind:value="option.labelid" v-text="option.label" />
                            </select>
                        </div>
                        <div class="col-md-4 row">
                            <label><strong>Marriage : From</strong></label>
                            <input class="form-control form-cascade-control input-small" v-model="marriagefrom"
                                type="date">
                        </div>
                        <div class="col-md-4 row">
                            <label><strong>Marriage : To</strong></label>
                            <input class="form-control form-cascade-control input-small" v-model="marriageto"
                                type="date">
                        </div>
                        <div class="col-md-4 row">
                            <label><strong>Email</strong></label>
                            <input class="form-control form-cascade-control input-small" v-model="email" type="text">
                        </div>
                        <div class="col-md-4 row">
                            <label><strong>By Religion</strong></label>
                            <select v-model="religion" class="form-control form-cascade-control input-small">
                                <option v-for="option in getmastertype(MASTER_RELIGION)" v-bind:key="option.labelid"
                                    v-bind:value="option.labelid" v-text="option.label" />
                            </select>
                        </div>

                        <div class="col-md-4 row">
                            <label><strong>Registration From</strong></label>
                            <input class="form-control form-cascade-control input-small" data-val="true"
                                v-model="registation_datefrom" data-val-required="Required" id="REGDATE" name="REGDATE"
                                type="date">
                        </div>
                        <div class="col-md-4 row">
                            <label><strong>Registration To</strong></label>
                            <input class="form-control form-cascade-control input-small" data-val="true"
                                v-model="registation_dateto" data-val-required="Required" id="REGDATE" name="REGDATE"
                                type="date">
                        </div>
                        <div class="col-md-4 row">
                            <label><strong>Pincode</strong></label>
                            <input class="form-control form-cascade-control input-small" data-val="true"
                                v-model="pincode" data-val-required="Required" id="REGDATE" name="REGDATE" type="text">
                        </div>
                        <div class="col-md-4 row">
                            <label><strong>Distance</strong></label>
                            <input class="form-control form-cascade-control input-small" v-model="distance" type="number"
                                min="0" step="any">
                        </div>
                        <div class="col-md-4 row">
                            <label><strong>Rating</strong></label>
                            <!-- <select class="form-control form-cascade-control input-small" v-model="customer_type">
                                <option value="A">A</option>
                                <option value="B">B</option>
                                <option value="C">C</option>
                                <option value="D">D</option>
                            </select> -->
                            <div class="form-control form-cascade-control input-small">
                                <input type="checkbox" @click="toggleRating('A')"  id="ratingA"/>
                                <label for="ratingA" class="mr-4">A</label>
                                <input type="checkbox" @click="toggleRating('B')"  id="ratingB"/>
                                <label for="ratingB" class="mr-4">B</label>
                                <input type="checkbox" @click="toggleRating('C')"  id="ratingC"/>
                                <label for="ratingC" class="mr-4">C</label>
                                <input type="checkbox" @click="toggleRating('D')"  id="ratingD"/>
                                <label for="ratingD" class="mr-4">D</label>
                                <input type="checkbox" @click="toggleRating('E')"  id="ratingE"/>
                                <label for="ratingE">None</label>
                            </div>
                        </div>
                        <div class="col-md-4 row">
                            <label><strong>Introducer Id</strong></label>
                            <input class="form-control form-cascade-control input-small" v-model="introducerid"
                                type="text" @input="fetchIntroducer()" placeholder="VSDIGI-ID">
                        </div>
                        <div class="col-md-4 row">
                            <label><strong>Customer Type</strong></label>
                            <select v-model="iscustomer" class="form-control form-cascade-control input-small">
                                <option :value="1" >Registered</option>
                                <option :value="0" >Un-Registered</option>
                            </select>
                        </div>
                        <div class="col-md-4" v-if="loginusercheck(271)">
                            <div class="row mt-20">
                                <div class="col-md-6 p-0">
                                    <select @change="chooseUser()" v-model="userrecord"
                                        class="form-control input-small">
                                        <option value="0">Select Page</option>
                                        <option v-for="item in noofuser" :key="item" :value="item">{{ item }}</option>
                                    </select>
                                </div>
                                <div class="col-md-6">
                                    <button @click="sendMessage()" class="btn btn-success input-small">
                                        <i class='bx bxl-whatsapp'></i>WhatsApp
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 on_bottom">
                            <!-- <strong>{{ this.introducer.name }} </strong> , <span> {{ this.introducer.mobile }}</span>
                            <br> -->
                            <div>
                                <button class="btn btn-primary" @click="openPointPage()">Set Referral Point</button>
                            </div>
                            <div >
                                <h6>Referral Points : {{ pointforallcustomer  ?? 0}}</h6> 
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 " style="display: flex;align-items: end;">
                        <div class="col-md-5 " style="display: flex;align-items: center;">
                            <div class="col-md-4">
                                <strong>Show Rec.</strong>
                            </div>
                            <div class="col-md-4">
                                <select class="form-control col-mb-1" v-model="noofrec" id="rec" @change="search()">
                                    <option :value=10>10</option>
                                    <option :value=25>25</option>
                                    <option :value=50>50</option>
                                    <option :value=100>100</option>
                                    <option :value=200>200</option>
                                    <option :value=500>500</option>
                                    <option :value=1000>1000</option>
                                </select>
                            </div>
                            <div class="col-md-4">
                                <button class="btn btn-primary" @click="exportExcel()">
                                    Excel
                                </button>
                            </div>
                        </div>
                        <div class="col-md-3"></div>

                        <div class="col-md-4 flex-around-row">
                            <button @click="search()" class="btn bg-success text-white username btnsearch"
                                style="margin-top:31px;" type="button"><i class='bx bx-search-alt-2'></i>
                                Apply Filters</button>
                            <button @click="reset()" class="btn bg-primary text-white username btnsearch"
                                style="margin-top:31px;" type="button"><i class="fa fa-times"></i> Clear</button>
                            <button @click="fetchLottery()" class="btn bg-primary text-white username btnsearch"
                                style="margin-top:31px;" type="button">Lucky Winner</button>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        <LuckyWinnerPage
            v-if="showLuckyWinner"
            :searchParams="luckyWinnerSearchParams"
            flowType="customer"
            @close="closeLuckyWinner"
        />
        <PointModal :isVisible="isModalVisible" @close="closePointModal()" />
    </div>
</template>
<script>
import debounce from 'lodash.debounce';
import Constants from '../../components/utilities/Constants.vue'
import { mapGetters } from 'vuex'
import moment from 'moment';
import axios from 'axios'
import PointModal from './PointModal.vue';
import LuckyWinnerPage from '../salesmanager/LuckyWinnerPage.vue';
export default {
    components:{PointModal,LuckyWinnerPage},
    props: ['displayfor'],
    mixins: [Constants],
    data() {
        return {
            iscustomer:1,
            registation_type: [],
            registrationTypeOptions: [
                { value: 1, label: 'Permanent' },
                { value: 2, label: 'Temporary' },
                { value: 3, label: 'Dummy' },
                { value: 4, label: 'App' },
                { value: 'not_set', label: 'Not set' },
            ],
            customername: '',
            mobile: '',
            address: '',
            generatedid: '',
            aadharno: '',
            dobfrom: '',
            dobto: '',
            registation_datefrom: '',
            registation_dateto: '',
            dateFilterStorageKey: null,
            searchMode: 'filters',
            religion: 0,
            gender: 0,
            email: null,
            searchdetails: true,
            pincode: 0,
            distance: '',
            userid: [],
            marriagefrom: '',
            marriageto: '',
            noofuser: 0,
            userrecord: 0,
            page: 1,
            noofrec: 10,
            alluser: [],
            customer_type: '',
            introducerid: '',
            introducer: {
                name: '',
                mobile: '',
                address: '',
            },
            moment:moment,
            selecteduser:null,
            position:0,
            isModalVisible: false,
            pointforallcustomer:0,
            selectedRating: [],
            showLuckyWinner: false,
            luckyWinnerSearchParams: null,
        }
    },
    computed: {
        ...mapGetters([
            'searchdata', 'userids', 'currentpage'
        ]),
        selectedDates() {
            return {
                registation_datefrom: this.registation_datefrom,
                registation_dateto: this.registation_dateto,
                dobfrom: this.dobfrom,
                dobto: this.dobto,
                marriagefrom: this.marriagefrom,
                marriageto: this.marriageto,
            }
        },
    },
    watch: {
        selectedDates: {
            deep: true,
            handler(dates) {
                if (!this.dateFilterStorageKey) return
                try {
                    localStorage.setItem(this.dateFilterStorageKey, JSON.stringify(dates))
                } catch (err) {
                    // Date filtering still works when browser storage is unavailable.
                }
            },
        },
        $route: function (to, from) {
            console.log(to)
            console.log(from)
            if (this.$route.params.id != null) {
                //console.log(this.$route.params.id)
                // if(this.searchdata.search=="vsdigi"){
                //     this.reset();
                //     this.generatedid=this.$route.params.id
                // }else if(this.searchdata.search=="number"){
                //     this.reset();
                //     this.mobile=this.$route.params.id
                // }else if(this.searchdata.search=="email"){
                //     this.reset();
                //     this.email=this.$route.params.id
                // }
                // else if(this.searchdata.search=="name"){
                //     this.reset();
                //     this.customername=this.$route.params.id
                // }
                this.searchdetails = false
            } else {
                this.searchdetails = true
                this.refresh();
            }
        },
        // noofuser() {
        //     return Math.ceil(parseInt(this.alluser?.length) / parseInt(this.noofrec))
        // }
    },
    mounted() {
        if (this.$route.params.id != null) {

            this.searchdetails = false
        } else {
            this.searchdetails = true
            this.refresh();
            this.fetchCompanyPoint()
        }
    },
    methods: {
        async restoreDateFilters() {
            if (this.dateFilterStorageKey) return
            const user = await this.waitForLoggedInUser()
            if (!user?.id) return
            const key = `vsdigi.customer.dates.${user.companyid}.${user.id}`
            try {
                const dates = JSON.parse(localStorage.getItem(key) || '{}')
                Object.keys(this.selectedDates).forEach(field => {
                    this[field] = typeof dates?.[field] === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dates[field])
                        ? dates[field] : ''
                })
            } catch (err) {
                // Ignore unavailable storage or malformed saved values.
            }
            this.dateFilterStorageKey = key
        },
        reset() {
            this.registation_type = [],
                this.customername = '',
                this.mobile = '',
                this.address = '',
                this.generatedid = '',
                this.aadharno = '',
                this.dobfrom = '',
                this.dobto = '',
                this.marriagefrom = ''
            this.marriageto = ''
            this.registation_datefrom = '',
            this.registation_dateto = '',
                this.religion = 0,
                this.gender = 0,
                this.email = null,
                this.searchdetails = true
            this.pincode = 0
            this.distance = ''
            this.noofuser = 0
            this.customer_type = ''
            this.introducerid = ''
            this.introducer.name = '',
                this.introducer.mobile = ''
            this.introducer.address = ''
            this.selectedRating = []
        },
        refresh() {
            this.searchdetails = true
        },

        search(resetPage = true) {
            this.searchMode = 'filters'
            if (resetPage) this.$store.commit('assigncurrentpage', 1)
            this.$store.commit("assignloadingstatus", 1)
            this.$store.commit('assignnoofrecord', this.noofrec)
            let param = this.buildSearchParams()
            if (this.displayfor == 1) {
                this.$http.post('api/users/fetch', param)
                    .then((response) => this.processResponse(response.data))
                    .catch((err) => {
                        console.log(err)
                    });
                this.$http.post('api/users/fetch/count', param)
                    .then((response) => this.processResponseCount(response.data))
                    .catch((err) => {
                        this.errorShow(err)
                    });
            }
        },
        quickSearch(resetPage = true) {
            this.searchMode = 'quick'
            if (resetPage) this.$store.commit('assigncurrentpage', 1)
            this.$store.commit("assignloadingstatus", 1)
            this.$store.commit('assignnoofrecord', this.noofrec)
            const param = {
                name: this.customername,
                generatedid: this.generatedid,
                mobile: this.mobile,
                iscustomer: this.iscustomer,
                noofrec: this.noofrec,
                currentpage: this.currentpage,
            }
            if (this.displayfor == 1) {
                this.$http.post('api/users/fetch', param)
                    .then((response) => this.processResponse(response.data))
                    .catch((err) => this.errorShow(err))
                this.$http.post('api/users/fetch/count', param)
                    .then((response) => this.processResponseCount(response.data))
                    .catch((err) => this.errorShow(err))
            }
        },
        searchPage(resetPage = false) {
            if (this.searchMode === 'quick') this.quickSearch(resetPage)
            else this.search(resetPage)
        },
        // processResponseSendMessageUser(data) {
        //     this.alluser = data.userlist

        //     this.$store.commit('assignusermobiles', null)
        //     // console.log("user ids", this.alluser)
        //     this.noofuser = Math.ceil(parseInt(this.alluser?.length) / parseInt(this.noofrec))


        // },
        processResponseCount(data) {
            this.$store.commit('assigncustomerscount', data)
        },
        processResponse(data) {
            this.$store.commit("assignloadingstatus", 0)
            this.$store.commit('assigncustomers', data)
        },
        processResponseCRM(data) {
            this.$store.commit("assignloadingstatus", 0)
            this.$store.commit('assigncrmschedule', data)
        },
        ProcessCRMcount(data) {
            this.$store.commit("assignloadingstatus", 0)
            this.$store.commit('assigncrmschedulecount', data)
        },
        sendMessage() {
            if (this.userids?.length > 0) {
                this.$store.commit('assignloadingstatus', 1)
                this.$store.commit('assignedititem', null)
                setTimeout(() => {
                    this.$store.commit('assignviewno', 4)
                    this.$store.commit('assignloadingstatus', 0)
                }, 500);
            } else {
                alert('Select page no.')
            }
        },
        chooseUser() {
            // console.log("no of rec", this.userrecord)
            let value = this.alluser?.slice((this.userrecord - 1) * this.noofrec, (this.userrecord - 1) * this.noofrec + this.noofrec);
            this.$store.commit('assignuserids', value)

        },
        // Built in the browser from vsdigi/users/fetch (same filters as the list).
        // CONTACT has every mobile of the customer, one per line in the same cell.
        async exportExcel() {
            this.$store.commit('assignloadingstatus', 1)
            try {
                const param = {
                    ...this.buildSearchParams(),
                    columns: 'id,name,generatedid,distance,created_at,customer_type',
                    with: 'mobiles,addressess,referraluser,enteredby'
                }
                const [{ default: ExcelJS }, response] = await Promise.all([
                    import(/* webpackChunkName: "exceljs" */ 'exceljs'),
                    this.$http.post('api/vsdigi/users/fetch', param)
                ])
                const customers = response.data ?? []

                const workbook = new ExcelJS.Workbook()
                const sheet = workbook.addWorksheet('Customers')
                sheet.columns = [
                    { header: '#', width: 6 },
                    { header: 'VSDIGI-ID', width: 16 },
                    { header: 'NAME', width: 25 },
                    { header: 'CONTACT', width: 18 },
                    { header: 'ADDRESS', width: 30 },
                    { header: 'LANDMARK', width: 20 },
                    { header: 'DISTANCE', width: 10 },
                    { header: 'PINCODE', width: 10 },
                    { header: 'REGISTRATION DATE', width: 18 },
                    { header: 'INTRODUCER', width: 30 },
                    { header: 'ENTRY BY', width: 20 },
                    { header: 'RATING', width: 8 },
                ]
                sheet.getRow(1).font = { bold: true }
                customers.forEach((customer, index) => {
                    const address = customer.addressess?.[0]
                    const mobiles = (customer.mobiles ?? []).map(m => m.mobile).filter(Boolean)
                    const introducer = customer.referraluser
                    sheet.addRow([
                        index + 1,
                        customer.generatedid ?? 'N/A',
                        customer.name ?? 'N/A',
                        mobiles.length ? mobiles.join('\n') : 'N/A',
                        address?.houseno ? `${address.houseno} ${address.street ?? ''}`.trim() : 'N/A',
                        address?.landmark ?? 'N/A',
                        customer.distance ?? 'N/A',
                        address?.zipcode ?? 'N/A',
                        customer.created_at ? moment(customer.created_at).format('YYYY-MM-DD') : 'N/A',
                        introducer ? `${introducer.generatedid ?? ''} ${introducer.name ?? ''}`.trim() : 'N/A',
                        customer.enteredby?.name ?? 'N/A',
                        customer.customer_type ?? 'N/A',
                    ])
                })
                // one mobile per line in the cell, kept as text (no 9.19E+11)
                sheet.getColumn(4).eachCell(cell => {
                    cell.numFmt = '@'
                    cell.alignment = { wrapText: true, vertical: 'top' }
                })

                const buffer = await workbook.xlsx.writeBuffer()
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = 'customer_report.xlsx'
                link.click()
                setTimeout(() => window.URL.revokeObjectURL(link.href), 1000)
            } catch (err) {
                console.log(err)
                this.$notify({ text: 'Excel export failed', type: 'error' })
            } finally {
                this.$store.commit('assignloadingstatus', 0)
            }
        },
        fetchIntroducer: debounce(
            function () {
                if (this.introducerid != "") {
                    let param = { generatedid: this.introducerid }
                    this.$http.post('api/user/getuserbygeneratedid', param)
                        .then(response => this.processUserResponse(response.data))
                        .catch(error => console.log(error));
                } else {
                    this.introducer.name = ''
                    this.introducer.mobile = ''
                    // this.introducer.address=''
                }

            },
            1000
        ),
        processUserResponse(data) {
            this.introducer.name = data.name
            if (data.mobiles?.length > 0) {
                this.introducer.mobile = data.mobiles[0].mobile
            }
            if (data.addressess?.length > 0) {
                this.introducer.address = data.addressess[0]
            }
        },
        testEmit() {
            this.$emit('trigger')
        },

        fetchLottery() {
            this.luckyWinnerSearchParams = this.buildSearchParams()
            this.showLuckyWinner = true
        },
        buildSearchParams() {
            return {
                email: this.email,
                registation_datefrom: this.registation_datefrom,
                religion: this.religion,
                gender: this.gender,
                registation_type: this.registation_type,
                name: this.customername,
                introducerid: this.introducerid,
                mobile: this.mobile,
                address: this.address,
                generatedid: this.generatedid,
                registation_dateto: this.registation_dateto,
                iscustomer: this.iscustomer,
                aadharno: this.aadharno,
                dobfrom: this.dobfrom,
                dobto: this.dobto,
                pincode: this.pincode,
                distance: this.distance,
                noofrec: this.noofrec,
                currentpage: this.currentpage,
                marriagefrom: this.marriagefrom,
                marriageto: this.marriageto,
                customer_type: this.customer_type,
                selectedRating: this.selectedRating,
            }
        },
        openPointPage() {
            this.isModalVisible = true;
            
        },
        closePointModal(){
            this.isModalVisible = false;
            this.fetchCompanyPoint()
        },
        closeLuckyWinner() {
            this.showLuckyWinner = false
            this.luckyWinnerSearchParams = null
        },
        fetchCompanyPoint(){
            axios.post('api/company/detail')
                .then(response => {
                    console.log(response.data.company)
                    let company = response.data.company
                    this.pointforallcustomer = JSON.parse(company.paramjson)?.points
                    // this.pointforallcustomer = response.data.point
                })
                .catch(err => {
                    console.log(err)
                });

        },
        toggleRating(rating) {
            // push rating 
            if (this.selectedRating.includes(rating)) {
                this.selectedRating = this.selectedRating.filter(item => item !== rating)
            } else {
                this.selectedRating.push(rating)
            }
            console.log("selected rating",this.selectedRating)

        }
        

    }
}
</script>
<style scoped>
.customer-quick-search,
.customer-advanced-search {
    padding: 12px 14px;
    margin-bottom: 14px;
    border: 1px solid #e9dbdb;
    border-radius: 5px;
}

.customer-search-section-title {
    margin-bottom: 10px;
    color: #3a476b;
    font-size: 14px;
    font-weight: 600;
}

.registration-type-checks {
    height: auto;
    min-height: 31px;
}

.quick-search-action {
    display: flex;
    justify-content: flex-end;
    margin-top: 8px;
}
</style>
